module.exports = __webpack_public_path__ + "static/Backgroundup-35e669ab766fc393b3b685307419fe1f.png";